//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceStatus } from './Enums';

export class AttendanceHistorySearchOptions extends ItemBase {
    StartDate: string | null = null;
    EndDate: string | null = null;
    HasVisibleLessonNotes: boolean | null = null;
    Statuses: AttendanceStatus[] = [];
    EventCategoryIDs: string[] = [];
    HasAttachments: boolean | null = null;

    constructor(initializer?: Partial<AttendanceHistorySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceHistorySearchOptions";
}
